import { actions } from './authActions'
import { getters } from './authGetters'
import { mutations } from './authMutations'

export const authStore = {
  namespaced: true,
  state: {
    api_token: null,
    user_name: null,
    request_complete: false,
    yipps_currency: 0,
    user_avatar_url: null
  },
  mutations,
  actions: actions,
  getters

}
